@if (!optInInvisible) {
    <ms-crm-promotion-status-button [promotion]="promotion" (buttonClick)="onButtonClick($event)" />
}
<div class="more-info" [class.with-link]="!!promotion.banner?.moreInfo" (click)="moreInfoClick($event)">
    {{ translations.MoreInfo }}
</div>
